import { LitElement, css, unsafeCSS } from 'lit';
import styles from './overlay.scss?inline';
import { FIXED_BODY_CLASS, SHOW_ATTRIBUTE } from '../constants';

export default class SotbitOverlay extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static overlays = [];

    static properties = {
        isShow: { type: Boolean, reflect: true, attribute: 'show' },
    };

    constructor() {
        super();
    }

    attributeChangedCallback(name, old, value) {
        super.attributeChangedCallback(name, old, value);

        if (name === SHOW_ATTRIBUTE && old !== value) {
            if (this.isShow) {
                this.show();
            } else {
                this.hide();
            }
        }
    }

    /**
     * @returns Promise
     */
    async show() {
        document?.body?.classList?.add(FIXED_BODY_CLASS);
        this.setAttribute(SHOW_ATTRIBUTE, '');
        await new Promise((res) => {
            this.addEventListener('transitionend', res, { once: true });
        });
    }

    /**
     * @returns Promise
     */
    async hide() {
        if (!this._getOtherOpenOverlays().length) {
            document?.body?.classList?.remove(FIXED_BODY_CLASS);
        }
        this.removeAttribute(SHOW_ATTRIBUTE);
        await new Promise((res) => {
            this.addEventListener('transitionend', res, { once: true });
        });
    }

    /**
     * @returns SotbitOverlay[]
     */
    _getOtherOpenOverlays() {
        return SotbitOverlay.overlays.filter((element) => {
            return element.getAttribute(SHOW_ATTRIBUTE) !== null;
        });
    }

    connectedCallback() {
        super.connectedCallback();

        SotbitOverlay.overlays.push(this);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        // avoid cleanup when overlay is only moved, not removed from the document
        queueMicrotask(() => {
            if (!this.isConnected) {
                SotbitOverlay.overlays = SotbitOverlay.overlays.filter((element) => element !== this);
                this.hide();
            }
        });
    }
}
